import {Button, SpaceBetween} from '@amzn/awsui-components-react-v3';
import React from 'react';
import { CHART_TYPE } from '../../../../constants/trend_report';

export class TrendReportChartTitle extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const switchType = this.props.chartType === CHART_TYPE.LINE? CHART_TYPE.BAR : CHART_TYPE.LINE;
    return (
      <div className="awsui-util-container-header">
        <div className="awsui-util-action-stripe">
          <div className="awsui-util-action-stripe-group">
            <div className="awsui-util-font-size-2">{this.props.text}</div>
          </div>
          <div className="awsui-util-f-r">
            <SpaceBetween direction="horizontal" size="xs">
            <Button
              variant="normal"
              iconName="download"
              disabled={this.props.allLinesId.length === 0 || this.props.data.length === 0}
              onClick={this.props.onDownloadDisplayedData}
            >
              Download Graph
            </Button>
            <Button
              variant="normal"
              disabled={this.props.allLinesId.length === 0}
              onClick={this.props.onChangeFn}
            >
              {`Switch to ${switchType} Chart`}
            </Button>
            </SpaceBetween>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/trend/trend_report_chart_title.js